// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const FolderOpenFilledIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 34 28">
    <path
      fill="url(#folder-open-filled_svga)"
      d="M30.33 4H17L13.67.67h-10A3.33 3.33 0 0 0 .35 4L.33 24c0 1.83 1.5 3.33 3.34 3.33h26.66c1.84 0 3.34-1.5 3.34-3.33V7.33c0-1.83-1.5-3.33-3.34-3.33m0 20H3.67V7.33h26.66z"
    />
    <defs>
      <linearGradient
        id="folder-open-filled_svga"
        x1={0.33}
        x2={27.29}
        y1={0.67}
        y2={32.7}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6E45E2" />
        <stop offset={1} stopColor="#A22E95" />
      </linearGradient>
    </defs>
  </svg>,
  "FolderOpenFilled",
);
export default FolderOpenFilledIcon;
